// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card-image-type-8-m__wrapper__23-2X","author-byline":"card-image-type-8-m__author-byline__3Tsn_"};